/**
 * Web variant of the Ionicons platform wrapper (see Ionicons.ts).
 *
 * The config plugin that registers the font on native does nothing on web, so
 * the `/static` entry would render tofu. The root entry bundles Ionicons.ttf
 * and dynamically loads it through expo-font, which injects the @font-face.
 */
export { default, type IoniconsIconName } from '@react-native-vector-icons/ionicons';
